import Settings from "@mui/icons-material/Settings";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { useDecodeVins } from "@/hooks/devices/useDecodeVins";
import { DeviceStatusOverviewData } from "@/models/DeviceStatusOverviewData";

export default function DeviceDetail({ row }: { row: DeviceStatusOverviewData }) {
  //@ts-ignore
  const { data: vinDetail } = useDecodeVins([row.device.vehicleIdentificationNumber]);
  const { make, model, vehicleType, year, vin } = vinDetail?.[0] ?? {};

  const fieldValues = [make, model, vehicleType, year, vin];
  const { t } = useTranslation();
  const fieldNames = [t("make"), t("model"), t("vehicleType"), t("year"), t("vin")];
  const visibleFields = fieldValues
    .map((value, index) => (value ? { label: fieldNames[index], value } : null))
    .filter(Boolean) as { label: string; value: string }[];

  const { database } = useGeotabClient();
  const url = `https://my.geotab.com/${database}/#device,id:${row.device.id}`;

  return (
    <Paper
      elevation={2}
      sx={{
        display: "flex",
        alignItems: "center",
        px: 2,
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
          overflow: "hidden",
          width: "100%",
        }}
      >
        {visibleFields.map((field, idx) => (
          <Tooltip key={idx} title={field.label}>
            <Typography
              variant="caption"
              noWrap
              sx={{ textOverflow: "ellipsis", overflow: "hidden" }}
            >
              {field.value}
              {idx < visibleFields.length - 1 && <>&nbsp;•</>}
            </Typography>
          </Tooltip>
        ))}

        <IconButton
          component="a"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
          aria-label="edit"
        >
          <Settings />
        </IconButton>
      </Box>
    </Paper>
  );
}
